import axios from 'axios'

import { parseResponse, handleError } from '@/_helpers/utils.js'

import Security from '@/_helpers/security.js'
import companies from './companies/index.js'
import company from './company/index.js'
import vacancies from './vacancies/index.js'
import vacancy from './vacancy/index.js'
import candidates from './candidates/index.js'
import candidate from './candidate/index.js'
import recruiters from './recruiters/index.js'
import recruiter from './recruiter/index.js'
import refills from './refills/index.js'
import activities from './activities/index.js'
import responseStatuses from './response-statuses/index.js'
import rates from './rates/index.js'
import personal_managers from './personal-managers/index.js'
import users from './users/index.js'
import user from './user/index.js'

const state = {
  loading: true,
  error: null
}

const actions = {
  authUser ({commit}, user) {
    commit('auth')

    Security.applyAdminToken();

    return axios.post('/1.0/user-access-tokens', {users: [{email: user.email}]})
      .then(response => {
        const data = parseResponse(response).data[0]
        const meta = parseResponse(response).meta;
        Security.applyAccessToken(data)

        if (meta && meta.redirect_domain) {
          window.location.href = `${meta.redirect_domain}/responses`;
          return;
        }
      })
      .then(commit('authSuccess'))
      .catch(err => {
        const error = handleError(err)
        commit('authFailure', error)
      })
  }
}

const mutations = {
  auth (state) {
    state.loading = true
  },

  authSuccess (state, data) {
    state.loading = false
  },

  authFailure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  modules: {
    companies,
    vacancies,
    vacancy,
    candidate,
    candidates,
    recruiters,
    recruiter,
    refills,
    company,
    activities,
    rates,
    users,
    user,
    'personal-managers': personal_managers,
    'response-statuses': responseStatuses
  }
}